export default __webpack_public_path__ + "static/media/mobileTriangle.fffab4cf.svg";